import {HeroSection} from "./HeroSection";
import React from "react";
import NewsListContent from "../newstList/NewsListContent";
import NewsListTitle from "../newstList/NewsListTitle";
import './Home.scss';


export function Home() {
    return (
        <>
            <div className="home-main-image">
                <HeroSection/>
                <div id='news-list-scroll-point' className='news-list-scroll-point'/>
            </div>
            <NewsListTitle value='У нас сейчас'/>
            <NewsListContent/>
        </>
    )
}
